import { useInfiniteQuery } from "react-query";
import axios from "infra/http";
import { ContaItemResponse, ContaFiltroType } from "../typings";

function useContasInfiniteScroll(params: Partial<ContaFiltroType>) {
  const parseValuesParams = Object.values(params)
    .map((value) => `${value}`)
    .join("-");

  return useInfiniteQuery(
    `/v1/conta-${parseValuesParams}`,
    async ({ pageParam }) => {
      const { data } = await axios.get<{ items: ContaItemResponse[] }>(
        `/v1/conta`,
        {
          params: {
            ...params,
            page: pageParam,
            pago:
              params.pago === true
                ? "1"
                : params.pago === false
                ? "0"
                : undefined,
            atraso:
              params.atraso === true
                ? "1"
                : params.atraso === false
                ? "0"
                : undefined,
          },
        }
      );

      return data;
    },
    {
      enabled: !!params.operacao,
      getNextPageParam: (lastPage, allPages) =>
        lastPage.items.length < 0 ? undefined : allPages.length + 1,
    }
  );
}

export default useContasInfiniteScroll;
